// Dietas de partida.
//
// Una cuenta nueva **arranca sin dieta**: las comidas están puestas pero vacías,
// y cada uno escribe la suya. La dieta concreta que hay más abajo es la del
// dueño de la app, que la traía en papel, y solo se siembra en su cuenta.

export const WEEKDAYS = [
  { id: "lun", name: "Lunes", short: "L" },
  { id: "mar", name: "Martes", short: "M" },
  { id: "mie", name: "Miércoles", short: "X" },
  { id: "jue", name: "Jueves", short: "J" },
  { id: "vie", name: "Viernes", short: "V" },
  { id: "sab", name: "Sábado", short: "S" },
  { id: "dom", name: "Domingo", short: "D" },
];

// Los cinco huecos del día. Estos sí valen para cualquiera: son la estructura
// de la pantalla, no el contenido de nadie. Se pueden renombrar y borrar.
export const DEFAULT_MEALS = [
  { id: "desayuno", name: "Desayuno" },
  { id: "aperitivo", name: "Aperitivo" },
  { id: "comida", name: "Comida" },
  { id: "merienda", name: "Merienda" },
  { id: "cena", name: "Cena" },
];

function emptyPlan() {
  const plan = {};
  DEFAULT_MEALS.forEach((meal) => {
    plan[meal.id] = WEEKDAYS.map(() => "");
  });
  return plan;
}

export const EMPTY_DIET = {
  meals: DEFAULT_MEALS,
  plan: emptyPlan(),
  note: "",
};

// ─── Dieta del dueño ──────────────────────────────────────────────────────────
//
// Se identifica por una huella del correo y no por el correo en claro: este
// archivo acaba en el JavaScript que sirve el navegador, donde cualquiera puede
// leerlo, y no hay motivo para dejar ahí una dirección de nadie.
//
// No es una medida de seguridad y no pretende serlo: quien la falsee se lleva
// una dieta de ejemplo. Solo evita publicar un correo y que esta dieta salga en
// cuentas ajenas.
const OWNER_FINGERPRINT = "1nrsx2k";

export function fingerprint(email) {
  let hash = 5381;
  const normalized = String(email || "").trim().toLowerCase();
  for (let i = 0; i < normalized.length; i++) {
    hash = ((hash << 5) + hash + normalized.charCodeAt(i)) >>> 0;
  }
  return hash.toString(36);
}

export function isOwner(email) {
  return !!email && fingerprint(email) === OWNER_FINGERPRINT;
}

const BURRITO = "Burrito (fajita + alubias (20 g) + queso ricotta o mozzarella (15 g)";
const POLLO = "Pollo (250 g) + arroz (100 g) + aceite de oliva";
const CARRILLERAS = "Carrilleras (200 g) + patatas (250 g)";
const HUEVOS = "3 huevos + jamón · Pipas";

// Transcrita del papel tal cual, con sus irregularidades: el queso de la
// merienda pasa de 35 a 45 g según el día y el relleno del burrito rota entre
// atún, carne picada y soja. Están así a propósito.
export const OWNER_DIET = {
  meals: DEFAULT_MEALS,
  // Siete posiciones por comida, de lunes a domingo.
  plan: {
    desayuno: Array(7).fill("Café + tortas de maíz (40 g)"),
    aperitivo: [
      "Almendras (25 g)",
      "Nueces (25 g)",
      "Almendras (25 g)",
      "Nueces (25 g)",
      "Almendras (25 g)",
      "Nueces (25 g)",
      "Almendras (25 g)",
    ],
    comida: [POLLO, CARRILLERAS, POLLO, CARRILLERAS, POLLO, CARRILLERAS, POLLO],
    merienda: [
      "Queso (35 g) + pan (50 g)",
      "Batido",
      "Queso (45 g) + pan (50 g)",
      "Batido",
      "Queso (45 g) + pan (50 g)",
      "Batido",
      "Queso (35 g) + pan (50 g)",
    ],
    cena: [
      `${BURRITO} + lata de atún)`,
      HUEVOS,
      `${BURRITO} + carne picada)`,
      HUEVOS,
      `${BURRITO} + soja)`,
      HUEVOS,
      `${BURRITO} + lata de atún)`,
    ],
  },
  note: "Los días libres, cheat meal: solo una comida, 4 al mes.",
};

// La dieta con la que arranca una cuenta que todavía no ha guardado nada.
export function starterDiet(email) {
  return isOwner(email) ? OWNER_DIET : EMPTY_DIET;
}
